const state = () => ({
  current: null,
  routes: [],
});

const actions = {
  setBreadcrumbsFromCategories({ commit }, { categories, productName }) {
    if (!categories || categories.length === 0) return;
    // 1. Sort categories by level, position, and id
    const sorted = [...categories].sort((a, b) => {
      if (b.level !== a.level) return b.level - a.level;
      if ((a.position ?? 9999) !== (b.position ?? 9999))
        return (a.position ?? 9999) - (b.position ?? 9999);
      return a.id - b.id;
    });

    const selectedCategory = sorted[0];
    const routes = [];

    // 2. Build breadcrumb trail using `breadcrumbs` if available
    if (selectedCategory.breadcrumbs?.length) {
      selectedCategory.breadcrumbs.forEach((crumb) => {
        routes.push({
          name: crumb.category_name,
          route_link: `/${crumb.category_url_key}`, // not shown in URL, but helpful if needed internally
        });
      });
    }

    // 3. Add the selected category itself
    routes.push({
      name: selectedCategory.name,
      route_link: `/${selectedCategory.url_key}`,
    });

    // Don’t decide about mobile here — let component filter
    commit("set", {
      routes,
      current: productName,
    });
  }
};

const mutations = {
  /**
   * set breadcrumbs
   * @param {object} state
   * @param {object} payload
   */
  set(state, payload) {
    state.routes = payload.routes;
    state.current = payload.current;
  },
};

const getters = {
  getBreadcrumbsRoutes: (state) => state.routes,
  getBreadcrumbsCurrent: (state) => state.current,
};

// export this module.
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
